// redux/slices/feedbackSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  captureFeedback: false,
  screenshot: null, // we can store the screenshot File here if needed
};

const feedbackSlice = createSlice({
  name: 'feedback',
  initialState,
  reducers: {
    triggerCapture: (state) => {
      state.captureFeedback = true;
      console.log("feedbackSlice: triggerCapture dispatched");
    },
    setScreenshot: (state, action) => {
      state.screenshot = action.payload;
      console.log("feedbackSlice: screenshot stored in state");
    },
    clearCapture: (state) => {
      state.captureFeedback = false;
      state.screenshot = null;
      console.log("feedbackSlice: capture cleared");
    },
  },
});

export const { triggerCapture, setScreenshot, clearCapture } = feedbackSlice.actions;
export default feedbackSlice.reducer;